import { render, staticRenderFns } from "./AllUsers.vue?vue&type=template&id=9985681a&"
import script from "./AllUsers.vue?vue&type=script&lang=ts&"
export * from "./AllUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports